import type React from "react";
import type { LegitimateAny } from "@kivra/sdk/types/util";

export function mergeRefs<T = LegitimateAny>(
  refs: Array<React.RefObject<T> | React.Ref<T>>,
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        (ref as React.RefObject<T | null>).current = value;
      }
    });
  };
}
